import { FormOutcomeModel } from "@alfresco/adf-core";

export enum FormBehaviour {
  CLOSE = "close",
  REDIRECT = "redirect",
}

export interface EbenFormOutcomeModel extends FormOutcomeModel {
  class?: string;
  behaviour?: FormBehaviour;
}


